import en from "application/messages/en.json";
import de from "application/messages/de.json";
import es from "application/messages/es.json";
import da from "application/messages/da.json";
import fr from "application/messages/fr.json";
import nl from "application/messages/nl.json";
import it from "application/messages/it.json";
import pt from "application/messages/pt.json";
import sr from "application/messages/sr.json";

export default {
  en,
  de,
  es,
  da,
  fr,
  nl,
  it,
  pt,
  sr,
};
